export const COMPONENT_NAME = "kyc-personal-information";
